import { _delete, _get, _patch, _save } from 'frontcore/utils/communications/apiClient'

export const URL_BASE_HSE_CATEGORIES = 'hse-risk-categories'
export const URL_BASE_HSE_PRIORITIES = 'hse-risk-priorities'
export const URL_BASE_HSE_RISKS = 'hse-risks'
export const URL_BASE_HSE_RISKS_FILTERS = 'hse-risk-filters'

export function fetchHSECategories () {
  const url = `${URL_BASE_HSE_CATEGORIES}/`
  return _get(url)
}

export function fetchHSEPriorities () {
  const url = `${URL_BASE_HSE_PRIORITIES}/`
  return _get(url)
}

export function fetchHSERisks () {
  const url = `${URL_BASE_HSE_RISKS}/`
  return _get(url)
}

export function fetchHSERiskById (id) {
  const url = `${URL_BASE_HSE_RISKS}/${id}/`
  return _get(url)
}

export function fetchHSEPriorityById (id) {
  const url = `${URL_BASE_HSE_PRIORITIES}/${id}/`
  return _get(url)
}

export function saveHSEPriority (data) {
  const url = `${URL_BASE_HSE_PRIORITIES}/`
  return _save(url, data, true)
}

export function createHSERisk (data) {
  const url = `${URL_BASE_HSE_RISKS}/`
  return _save(url, data, true)
}

export function deleteHSEPriorityById (id) {
  const url = `${URL_BASE_HSE_PRIORITIES}/${id}/`
  return _delete(url)
}

export function deleteHSERiskById (id) {
  const url = `${URL_BASE_HSE_RISKS}/${id}/`
  return _delete(url)
}

export function patchHSEPriorityById (id, data) {
  const url = `${URL_BASE_HSE_PRIORITIES}/${id}/`
  return _patch(url, data)
}

export function patchHSERiskById (id, data) {
  const url = `${URL_BASE_HSE_RISKS}/${id}/`
  return _patch(url, data)
}

export function updateHSERisk (id, data) {
  const url = `${URL_BASE_HSE_RISKS}/${id}/`
  return _save(url, data, false)
}
